import Client from '@/clients/apiClient';

export default {
  get() {
    return Client.get('');
  },
  getSelf() {
    return Client.get('/me');
  },
  register(payload) {
    return Client.post('/register', payload);
  },
  update(id, payload) {
    return Client.put(`/${id}`, payload);
  },
  validateIsUnique(payload) {
    return Client.post(`/validate`, payload);
  },
};
